module.exports = __webpack_public_path__ + "assets/03df32a1e0e75375d67753000c1e21d6.mp3";